export const variables = {
    // API_URL: "https://api-mtb.master-planner.net/api/",
    // PHOTO_URL: "https://www.master-planner.net/Fotos/",
    API_URL: "https://api-mtbdev.master-planner.net/api/",
    PHOTO_URL: "https://www.master-planner.net/FotosDev/",
    // API_URL: "https://localhost:7214/api/",
    // PHOTO_URL: "http://localhost:3000/Images/"
}